import { defineStore } from 'pinia'
import { ref, shallowRef } from 'vue'
import { CaseService } from '@/services/telehealthApi/CaseService'
import type { MedicalFieldDTO } from '@/generated'

export type MedicalFieldsStatus = 'idle' | 'loading' | 'ready' | 'error'

export const useMedicalFieldsStore = defineStore('medicalFields', () => {
  const medicalFieldsById = shallowRef<ReadonlyMap<string, MedicalFieldDTO>>(new Map())
  const status = ref<MedicalFieldsStatus>('idle')

  const toMap = (fields: MedicalFieldDTO[]) =>
    new Map(fields.map((field) => [field.id, field] as const))

  async function fetchFields(): Promise<void> {
    status.value = 'loading'
    try {
      const { medicalFields } = await CaseService.getMedicalFields()
      medicalFieldsById.value = toMap(medicalFields)
      status.value = 'ready'
    } catch (error) {
      status.value = 'error'
      throw error
    }
  }

  function load(): Promise<void> {
    if (status.value === 'ready') return Promise.resolve()
    return fetchFields()
  }

  return { medicalFieldsById, status, load }
})
